export const CAR_INFO_LIST_REQUEST = 'CAR_INFO_LIST_REQUEST';

export const CAR_BOX_INFO_LIST_REQUEST = 'CAR_BOX_INFO_LIST_REQUEST';

export const WALLET_INFO_LIST_REQUEST = 'WALLET_INFO_LIST_REQUEST';

export const NFT_GEAR_INFO_LIST_REQUEST = 'NFT_GEAR_INFO_LIST_REQUEST';

export const BRIDGE_WALLET_INFO_REQUEST = 'BRIDGE_WALLET_INFO_REQUEST';

export const PILOT_INFO_LIST_REQUEST = 'PILOT_INFO_LIST_REQUEST';
